import cx from 'classnames';
import * as React from 'react';

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  iconHref: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
}

/**
 * `SvgIcon` is used to display the svg icon as listed in [styleguide](https://styleguide.topdanmark.dk/components/detail/flos-icons.html)
 */
export const SvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function SvgIcon(
  { size, iconHref, className, focusable = 'false', 'aria-hidden': ariaHidden = true, ...props },
  forwardedRef
) {
  return (
    <svg
      className={cx('tds-Icon', size && `tds-Icon--${size}`, className)}
      focusable={focusable}
      aria-hidden={ariaHidden}
      {...props}
      ref={forwardedRef}
    >
      <use xlinkHref={iconHref} />
    </svg>
  );
});
